import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }
});
export const figure2 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        height: '450px',
        backgroundColor: 'rgba(255, 255, 255, 0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
      exporting: {
        enabled: false
      },
      legend: {
        enabled: false,
      },
      xAxis: [{
        categories: [ 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020 ],
        tickInterval: 1,
        crosshair: {
            width: 1,
            color: '#d7d7d7'
        },
        lineColor: "#d7d7d7",
        tickColor: "#d7d7d7",
        tickLength: 16,
        labels: {
            y: 32,
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            }
        },
    }],

    yAxis: [
        {
        labels: {
            format: '{value}',
            style: {
                fontWeight: 'normal',
                color: '#999999',
                fontSize: '12px'
            },
        },
        offset: 10,
        gridLineWidth: 2,
        max: 50,
        min: 0,
        tickInterval: 10,
        title: {
            text: null,
            style: {
                color: Highcharts.getOptions().colors[1]
            }
        }
    }],
    tooltip: {
        shared: true,
        useHTML: true,
        hideDelay: 500,
        backgroundColor: null,
        borderWidth: 0,
        shadow: false,
        style: {
            padding: 0
        }
    },
    plotOptions: {
        series: {
            states: {
                hover: {
                    lineWidth: 2
                }
            },
            marker: {
                symbol: 'circle',
                states: {
                    hover: {
                        enabled: true,
                        radius: 5
                    }
                }
            }
        }
    },
    series: [ {
        name: '',
        id: "prev",
        type: 'line',
        color: '#bababa',
        zoneAxis: 'x',
        dataLabels: {
            enabled: false,
            style: {
                fontWeight: 'normal',
                textOutline: false,
                color: '#999999',
                fontSize: '12px'
            }
        },

        data: [
          { y: 11.0, dataLabels: {enabled:true} },
          { y: 40.0, dataLabels: {enabled:true} },
          { y: 15.9, dataLabels: {enabled:true} },
          { y: 19.8, dataLabels: {enabled:true} },
          { y: 0.2, dataLabels: {enabled:true} },
          { y: 19.1, dataLabels: {enabled:true} },
          { y: 19.0, dataLabels: {enabled:true} },
          { y: 3.2, dataLabels: {enabled:true} },
          { y: 0.2, dataLabels: {enabled:true} },
          { y: 3.9, dataLabels: {enabled:true} },
          { y: 1.6, dataLabels: {enabled:true} },
          { y: 11.6, dataLabels: {enabled:true} },
          { y: 9.4, dataLabels: {enabled:true} },
          { y: 17.4, dataLabels: {enabled:true} },
          { y: 19.6, dataLabels: {enabled:true} },
          { y: 43.9, dataLabels: {enabled:true} }
        ]},
  ],

}